module.exports = __webpack_public_path__ + "img/lockcard.png";